import { render, staticRenderFns } from "./NewsCardSocial.vue?vue&type=template&id=1b2fbc68"
import script from "./NewsCardSocial.vue?vue&type=script&lang=js"
export * from "./NewsCardSocial.vue?vue&type=script&lang=js"
import style0 from "./NewsCardSocial.vue?vue&type=style&index=0&id=1b2fbc68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports